var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgD50ThumbnailBlack = function SvgD50ThumbnailBlack(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "d-50-thumbnail-black_svg__a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceGraphic",
    values: "0 0 0 0 0.686275 0 0 0 0 0.666667 0 0 0 0 0.737255 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#d-50-thumbnail-black_svg__a)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(10 10)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    y: 16,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    width: 14,
    height: 14,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 14,
    height: 14,
    rx: 2
  })))));
};
export default SvgD50ThumbnailBlack;